<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.8999 23.4287H34.1002"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.5352 22.8857L17.5636 23.4293"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M36.1289 22.8857L34.1004 23.4293"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.4282 27.7148H20.8569"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M31.1416 27.7148H34.5702"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M25.6997 27.7148H26.2997"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M34.2493 34.2503H31.9993C31.8004 34.2503 31.6096 34.1713 31.469 34.0306C31.3283 33.89 31.2493 33.6992 31.2493 33.5003V31.2502H20.7491V33.5003C20.7491 33.6992 20.6701 33.89 20.5294 34.0306C20.3888 34.1713 20.198 34.2503 19.9991 34.2503H17.749C17.5501 34.2503 17.3594 34.1713 17.2187 34.0306C17.078 33.89 16.999 33.6992 16.999 33.5003V25.2501L19.8022 18.95C19.8604 18.8167 19.956 18.7032 20.0775 18.6233C20.199 18.5434 20.3412 18.5006 20.4866 18.5H31.5118C31.6572 18.5006 31.7993 18.5434 31.9208 18.6233C32.0424 18.7032 32.138 18.8167 32.1962 18.95L34.9994 25.2501V33.5003C34.9994 33.6992 34.9203 33.89 34.7797 34.0306C34.639 34.1713 34.4483 34.2503 34.2493 34.2503Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.8999 11.4287H22.1002"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.53516 10.8857L5.56364 11.4293"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24.1289 10.8857L22.1004 11.4293"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.42822 15.7148H8.85686"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.1416 15.7148H22.5702"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.6997 15.7148H14.2997"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.2493 19.2502H8.74909V21.5003C8.74909 21.6992 8.67007 21.89 8.52942 22.0306C8.38876 22.1713 8.198 22.2503 7.99908 22.2503H5.74904C5.55012 22.2503 5.35935 22.1713 5.2187 22.0306C5.07804 21.89 4.99902 21.6992 4.99902 21.5003V13.2501L7.8022 6.95001C7.86037 6.81672 7.95603 6.70323 8.07754 6.62333C8.19905 6.54343 8.34117 6.50058 8.48659 6.5H19.5118C19.6572 6.50058 19.7993 6.54343 19.9208 6.62333C20.0424 6.70323 20.138 6.81672 20.1962 6.95001L22.9994 13.2501V18.2002"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
